// extracted by mini-css-extract-plugin
export default {"reactSelectContainer":"purchaseReg_reactSelectContainer__9p5Hi","table_wraper":"purchaseReg_table_wraper__IIYs6"};